<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Tipos Links" />

      <Lynx-Button
        text="Cadastrar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="showModalTipoLink()"
      />

      <Lynx-Button
        text="Voltar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="voltar()"
      />
    </div>
    <div v-if="pagination">
      <b-table
        :columns="columns"
        :data="loading ? [] : lista_tipos_link"
        :loading="loading"
        backend-pagination
        paginated
        @page-change="onPageChange"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
      >
        <template slot-scope="props" v-if="props.row.id != null">
          <b-table-column field="id">
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="nome">
            {{ props.row.nome }}
          </b-table-column>

          <b-table-column field="descricao">
            {{ props.row.descricao }}
          </b-table-column>

          <b-table-column field="created_at">
            {{ props.row.created_at | formatEnToBr }}
          </b-table-column>

          <b-table-column field="acoes">
            <div class="flex text-sm">
              <div class="flex text-sm items-center">
                <Lynx-Button
                  class=""
                  icon-size="7"
                  text="Atualizar"
                  size="small"
                  @click.native="atualizar(props.row)"
                />
                <!-- <Lynx-Button
                class=""
                icon-size="7"
                icon="Trash"
                size="small"
                @click.native="confirmDelete(props.row)"
              /> -->
              </div>
            </div>
          </b-table-column>
        </template>
        <template v-slot:empty>
          <NotFoundData text="Nenhum tipo encontrado!" />
        </template>
      </b-table>
    </div>

    <b-modal :active.sync="modalTipoLink" :width="600">
      <div class="bg-white p-5">
        <Lynx-Title text="Competência da Planilha" />

        <div>
          <Lynx-Label label="nome" />
          <Lynx-Input
            v-model="form.nome"
            placeholder="Digite o nome do tipo link"
          />
        </div>

        <div>
          <Lynx-Label label="Descrição" />
          <Lynx-Input
            v-model="form.descricao"
            placeholder="Digite a descrição do tipo link"
          />
        </div>
      </div>
      <footer class="modal-card-foot flex justify-between">
        <b-button
          @click.native="hideModalTipoLink()"
          type="is-danger"
          class="mt-4"
          >Cancelar</b-button
        >
        <b-button
          @click.native="confirm(lista_campos == null ? 'cria' : 'edita')"
          type="is-primary"
          class="ml-4 mt-4"
          >Salvar</b-button
        >
      </footer>
    </b-modal>
  </div>
</template>
  
  <script>
import { empresasMotivosDesativamentoRequest } from "@/services/requests/empresas";

import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";
import { monthNames } from "@/utils/utils";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";

export default {
  components: { NotFoundData, Treeselect },
  data() {
    return {
      monthNames,
      form: {
        nome: "",
        descrição: "",
      },
      modalTipoLink: false,
      loading: false,
      lista_campos: null,

      columns: [
        {
          field: "id",
          label: "Id",
          sortable: true,
        },

        {
          field: "nome",
          label: "Nome",
          sortable: true,
        },

        {
          field: "descricao",
          label: "Descrição",
          sortable: true,
        },

        {
          field: "created_at",
          label: "criação",
        },
        {
          field: "acoes",
          label: "Ações",
        },
      ],

      filtros: {
        page: 1,
        perPage: 10,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  computed: {
    ...mapGetters(["getToken"]),

    tipos_link() {
      return this.$store.state.tipoLink.lista_tipos_link;
    },

    lista_tipos_link() {
      return this.tipos_link.data;
    },

    pagination() {
      return this.tipos_link.pagination;
    },
    mensagem_alert() {
      return this.$store.state.tipoLink.mensagem_alert;
    },
    lista_colunas() {
      return this.$store.state.tipoLink.lista_colunas.map((coluna) => {
        return {
          id: coluna,
          label: coluna,
        };
      });
    },
    lista_tipo() {
      return TiposEnum;
    },
    lista_setor() {
      return SetoresEnum;
    },
  },

  watch: {
    "form.setor": function (value) {
      console.log(value);

      let subSetores = [];
      switch (value) {
        case "contabilidade":
          subSetores = ContabilidadeSubSetoresEnum;
          break;
        case "legalizacao e onboarding":
          subSetores = LegalizacaoSubSetoresEnum;
          break;
        case "cs":
          subSetores = CsSubSetoresEnum;
          break;
        default:
          subSetores = [];
      }
      this.lista_sub_setor = subSetores;
    },

    "form.integracao": function (value) {
      if (value == "MotivoDesativacao") {
        this.fetchMotivosDesativamento();
      }
    },
    "filtros.perPage"() {
      this.listar_tipos_link();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_tipos_link();
    },
  },

  mounted() {
    this.listar_tipos_link();
  },
  filters: {
    formatEnToBr,
  },
  methods: {
    hasRole,

    hideModalTipoLink() {
      this.modalTipoLink = false;
    },

    showModalTipoLink() {
      this.modalTipoLink = true;
      this.lista_campos = null;
      this.form = {
        nome: "",
        descrição: "",
      };
    },
    showModalTipoLinkUpdate() {
      this.modalTipoLink = true;
    },

    async confirm(tipo) {
      if (!this.hasRole("super-admin")) {
        this.$snack.error("Você não tem permissão para realizar esta ação");
      } else {
        this.form.colunas = JSON.stringify(this.colunas);
        this.form.regime_tributario = JSON.stringify(this.regimes_tributario);
        if (this.form.integracao == "MotivoDesativacao") {
          this.form.status = JSON.stringify(this.statusIntegracao);
        }
        await this.$buefy.dialog.confirm({
          message: `Esta ação  ` + tipo + ` um tipo de atividade no sistema?`,
          confirmText: "Sim",
          cancelText: "Não",
          type: "is-success",
          onConfirm: () => {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          },
        });
      }
    },

    async create() {
      this.loading = true;

      this.$store.dispatch("configEmpresa/atualizar", "");
      await this.$store
        .dispatch("tipoLink/create_tipo_link", this.form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.hideModalTipoLink();
        })
        .catch((error) => this.$snack.error(mensagem_alert.message))
        .finally(() => (this.loading = false));
    },

    async update() {
      this.loading = true;
      this.$store.dispatch("configEmpresa/atualizar", "");

      await this.$store
        .dispatch("tipoLink/update_tipo_link", this.form)

        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.hideModalTipoLink();
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));
    },
    async listar_tipos_link() {
      this.loading = true;

      const { filtros } = this;
      await this.$store.dispatch("tipoLink/listar_tipos_link", filtros);
      this.loading = false;
    },

    atualizar(value) {
      this.lista_campos = value;
      this.form = {
        id: value.id,
        nome: value.nome,
        descricao: value.descricao,
      };

      this.showModalTipoLinkUpdate();
    },

    async fetchMotivosDesativamento() {
      this.loading = true;
      let motivosOptions = [];
      await empresasMotivosDesativamentoRequest()
        .then((res) => (motivosOptions = res.data))
        .finally(() => (this.loading = false));

      this.motivosOptions = motivosOptions.map((motivo) => ({
        id: motivo.motivo,
        label: motivo.motivo,
      }));
    },
    onPageChange(page) {
      this.current_page = page;
    },
    voltar() {
      this.$router.push({
        name: "links.index",
        params: { setor: this.$route.params.setor },
      });
    },
  },
};
</script>

<style scoped>
</style>
  